// import React, { useState } from 'react';
// import Layout from '../../Component/Layout/Layout';
// import '../../Styles/commissions.css';

// const CommissionReport = () => {
//   const [dateRange, setDateRange] = useState({
//     startDate: '',
//     endDate: '',
//   });
//   const [showAllCommissions, setShowAllCommissions] = useState(false);
//   const [filteredCommissions, setFilteredCommissions] = useState([]);
//   const [isFiltered, setIsFiltered] = useState(false);

//   // Extended commissions data
//   const allCommissions = [
//     {
//       id: 1,
//       bookingId: 'BK001',
//       customer: 'John Smith',
//       bookingAmount: '₹5,000',
//       commissionRate: '15%',
//       commissionAmount: '₹750',
//       date: '2024-01-15',
//       status: 'Paid',
//       paymentDate: '2024-01-20'
//     },
//     {
//       id: 2,
//       bookingId: 'BK002',
//       customer: 'Alice Johnson',
//       bookingAmount: '₹3,200',
//       commissionRate: '15%',
//       commissionAmount: '₹480',
//       date: '2024-01-14',
//       status: 'Pending',
//       paymentDate: '-'
//     },
//     {
//       id: 3,
//       bookingId: 'BK003',
//       customer: 'Bob Wilson',
//       bookingAmount: '₹7,800',
//       commissionRate: '15%',
//       commissionAmount: '₹1,170',
//       date: '2024-01-13',
//       status: 'Paid',
//       paymentDate: '2024-01-18'
//     },
//     {
//       id: 4,
//       bookingId: 'BK004',
//       customer: 'Sarah Davis',
//       bookingAmount: '₹2,500',
//       commissionRate: '15%',
//       commissionAmount: '₹375',
//       date: '2024-01-12',
//       status: 'Paid',
//       paymentDate: '2024-01-17'
//     },
//     {
//       id: 5,
//       bookingId: 'BK005',
//       customer: 'Mike Brown',
//       bookingAmount: '₹4,500',
//       commissionRate: '15%',
//       commissionAmount: '₹675',
//       date: '2024-01-11',
//       status: 'Paid',
//       paymentDate: '2024-01-16'
//     },
//     {
//       id: 6,
//       bookingId: 'BK006',
//       customer: 'Emma Wilson',
//       bookingAmount: '₹6,200',
//       commissionRate: '15%',
//       commissionAmount: '₹930',
//       date: '2024-01-10',
//       status: 'Pending',
//       paymentDate: '-'
//     },
//     {
//       id: 7,
//       bookingId: 'BK007',
//       customer: 'David Lee',
//       bookingAmount: '₹3,800',
//       commissionRate: '15%',
//       commissionAmount: '₹570',
//       date: '2024-01-09',
//       status: 'Paid',
//       paymentDate: '2024-01-14'
//     },
//     {
//       id: 8,
//       bookingId: 'BK008',
//       customer: 'Lisa Garcia',
//       bookingAmount: '₹5,500',
//       commissionRate: '15%',
//       commissionAmount: '₹825',
//       date: '2024-01-08',
//       status: 'Paid',
//       paymentDate: '2024-01-13'
//     }
//   ];

//   // Use filtered commissions or all commissions
//   const displayedCommissions = isFiltered ? filteredCommissions : allCommissions.slice(0, 5);
//   const allDisplayedCommissions = isFiltered ? filteredCommissions : allCommissions;

//   // Calculate summary based on displayed data
//   const calculateSummary = (commissions) => {
//     const totalCommissions = commissions.reduce((sum, comm) => {
//       const amount = parseInt(comm.commissionAmount.replace('₹', '').replace(',', ''));
//       return sum + amount;
//     }, 0);
    
//     const paidCommissions = commissions
//       .filter(comm => comm.status === 'Paid')
//       .reduce((sum, comm) => {
//         const amount = parseInt(comm.commissionAmount.replace('₹', '').replace(',', ''));
//         return sum + amount;
//       }, 0);

//     return {
//       totalCommissions: `₹${totalCommissions.toLocaleString()}`,
//       paidCommissions: `₹${paidCommissions.toLocaleString()}`,
//       pendingCommissions: `₹${(totalCommissions - paidCommissions).toLocaleString()}`,
//       totalBookings: commissions.length
//     };
//   };

//   const summary = calculateSummary(allDisplayedCommissions);

//   const handleDateChange = (e) => {
//     setDateRange({
//       ...dateRange,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleFilter = (e) => {
//     e.preventDefault();
    
//     if (!dateRange.startDate || !dateRange.endDate) {
//       alert('Please select both start and end dates');
//       return;
//     }

//     const filtered = allCommissions.filter(commission => {
//       const commissionDate = new Date(commission.date);
//       const startDate = new Date(dateRange.startDate);
//       const endDate = new Date(dateRange.endDate);
      
//       return commissionDate >= startDate && commissionDate <= endDate;
//     });

//     setFilteredCommissions(filtered);
//     setIsFiltered(true);
//   };

//   const handleReset = () => {
//     setDateRange({
//       startDate: '',
//       endDate: '',
//     });
//     setFilteredCommissions([]);
//     setIsFiltered(false);
//   };

//   const handleExportCSV = () => {
//     const commissionsToExport = isFiltered ? filteredCommissions : allCommissions;
    
//     // Create CSV content
//     const headers = ['Booking ID', 'Customer', 'Booking Amount', 'Commission Rate', 'Commission Amount', 'Date', 'Status', 'Payment Date'];
//     const csvContent = [
//       headers.join(','),
//       ...commissionsToExport.map(commission => [
//         commission.bookingId,
//         `"${commission.customer}"`,
//         commission.bookingAmount,
//         commission.commissionRate,
//         commission.commissionAmount,
//         commission.date,
//         commission.status,
//         commission.paymentDate
//       ].join(','))
//     ].join('\n');

//     // Create and download CSV file
//     const blob = new Blob([csvContent], { type: 'text/csv' });
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.setAttribute('hidden', '');
//     a.setAttribute('href', url);
//     a.setAttribute('download', `commissions_report_${new Date().toISOString().split('T')[0]}.csv`);
//     document.body.appendChild(a);
//     a.click();
//     document.body.removeChild(a);
//     window.URL.revokeObjectURL(url);
//   };

//   const handleViewAll = () => {
//     setShowAllCommissions(true);
//   };

//   const closeModal = () => {
//     setShowAllCommissions(false);
//   };

//   return (
//     <Layout>
//       <div className="commissions-page">
//         <div className="page-header">
//           <h1 className="page-title">Commission Reports</h1>
//           <p className="page-subtitle">Track your commission earnings and performance</p>
//         </div>

//         {/* Summary Cards */}
//         <div className="summary-cards">
//           <div className="summary-card">
//             <div className="summary-icon total">💰</div>
//             <div className="summary-content">
//               <h3>{summary.totalCommissions}</h3>
//               <p>Total Commissions</p>
//             </div>
//           </div>
//           <div className="summary-card">
//             <div className="summary-icon paid">✅</div>
//             <div className="summary-content">
//               <h3>{summary.paidCommissions}</h3>
//               <p>Paid Commissions</p>
//             </div>
//           </div>
//           <div className="summary-card">
//             <div className="summary-icon pending">⏳</div>
//             <div className="summary-content">
//               <h3>{summary.pendingCommissions}</h3>
//               <p>Pending Commissions</p>
//             </div>
//           </div>
//           <div className="summary-card">
//             <div className="summary-icon bookings">📦</div>
//             <div className="summary-content">
//               <h3>{summary.totalBookings}</h3>
//               <p>Total Bookings</p>
//             </div>
//           </div>
//         </div>

//         {/* Filters */}
//         <div className="filters-section">
//           <form onSubmit={handleFilter} className="filter-form">
//             <div className="filter-group">
//               <label htmlFor="startDate">From Date</label>
//               <input
//                 type="date"
//                 id="startDate"
//                 name="startDate"
//                 value={dateRange.startDate}
//                 onChange={handleDateChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label htmlFor="endDate">To Date</label>
//               <input
//                 type="date"
//                 id="endDate"
//                 name="endDate"
//                 value={dateRange.endDate}
//                 onChange={handleDateChange}
//               />
//             </div>
//             <button type="submit" className="filter-btn">
//               Apply Filter
//             </button>
//             <button type="button" className="reset-btn" onClick={handleReset}>
//               Reset
//             </button>
//           </form>
//           {isFiltered && (
//             <div className="filter-info">
//               Showing {filteredCommissions.length} commissions from {dateRange.startDate} to {dateRange.endDate}
//             </div>
//           )}
//         </div>

//         {/* Commissions Table */}
//         <div className="commissions-table-container">
//           <div className="table-header">
//             <h3>Commission History</h3>
//             <div className="table-actions">
//               <button className="view-all-btn" onClick={handleViewAll}>
//                 View All
//               </button>
//               <button className="export-btn" onClick={handleExportCSV}>
//                 Export CSV
//               </button>
//             </div>
//           </div>
//           <div className="table-responsive">
//             <table className="commissions-table">
//               <thead>
//                 <tr>
//                   <th>Booking ID</th>
//                   <th>Customer</th>
//                   <th>Booking Amount</th>
//                   <th>Commission Rate</th>
//                   <th>Commission Amount</th>
//                   <th>Booking Date</th>
//                   <th>Status</th>
//                   <th>Payment Date</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {displayedCommissions.map((commission) => (
//                   <tr key={commission.id}>
//                     <td className="booking-id">{commission.bookingId}</td>
//                     <td className="customer">{commission.customer}</td>
//                     <td className="booking-amount">{commission.bookingAmount}</td>
//                     <td className="commission-rate">{commission.commissionRate}</td>
//                     <td className="commission-amount">{commission.commissionAmount}</td>
//                     <td className="date">{commission.date}</td>
//                     <td>
//                       <span className={`status-badge status-${commission.status.toLowerCase()}`}>
//                         {commission.status}
//                       </span>
//                     </td>
//                     <td className="payment-date">{commission.paymentDate}</td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//             {!isFiltered && allCommissions.length > 5 && (
//               <div className="table-footer">
//                 <p>Showing 5 of {allCommissions.length} commissions</p>
//               </div>
//             )}
//             {isFiltered && filteredCommissions.length === 0 && (
//               <div className="table-footer">
//                 <p>No commissions found for the selected date range</p>
//               </div>
//             )}
//           </div>
//         </div>

//         {/* All Commissions Modal */}
//         {showAllCommissions && (
//           <div className="modal-overlay" onClick={closeModal}>
//             <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//               <div className="modal-header">
//                 <h3>All Commissions ({allDisplayedCommissions.length})</h3>
//                 <button className="modal-close" onClick={closeModal}>×</button>
//               </div>
//               <div className="modal-body">
//                 <div className="commissions-table">
//                   <table>
//                     <thead>
//                       <tr>
//                         <th>Booking ID</th>
//                         <th>Customer</th>
//                         <th>Booking Amount</th>
//                         <th>Commission Rate</th>
//                         <th>Commission Amount</th>
//                         <th>Booking Date</th>
//                         <th>Status</th>
//                         <th>Payment Date</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {allDisplayedCommissions.map((commission) => (
//                         <tr key={commission.id}>
//                           <td className="booking-id">{commission.bookingId}</td>
//                           <td className="customer">{commission.customer}</td>
//                           <td className="booking-amount">{commission.bookingAmount}</td>
//                           <td className="commission-rate">{commission.commissionRate}</td>
//                           <td className="commission-amount">{commission.commissionAmount}</td>
//                           <td className="date">{commission.date}</td>
//                           <td>
//                             <span className={`status-badge status-${commission.status.toLowerCase()}`}>
//                               {commission.status}
//                             </span>
//                           </td>
//                           <td className="payment-date">{commission.paymentDate}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//               <div className="modal-footer">
//                 <button className="export-btn" onClick={handleExportCSV}>
//                   Export CSV
//                 </button>
//                 <button className="close-btn" onClick={closeModal}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </Layout>
//   );
// };

// export default CommissionReport;

import React, { useState, useEffect } from 'react';
import { getInfluencerCommissions } from '../../Services/Operations/ProductAPI';
import Layout from '../../Component/Layout/Layout';
import '../../Styles/commissions.css';
import { useSelector } from 'react-redux';

const CommissionReport = () => {
  const [commissions, setCommissions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dateRange, setDateRange] = useState({
    startDate: '',
    endDate: '',
  });
  const [statusFilter, setStatusFilter] = useState('All');
  const [showAllCommissions, setShowAllCommissions] = useState(false);
  const [filteredCommissions, setFilteredCommissions] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const { token, loginData } = useSelector(state => state.influencer);

  useEffect(() => {
    fetchCommissions();
  }, []);

  const fetchCommissions = async (filterParams = {}) => {
    try {
      const response = await getInfluencerCommissions(filterParams, token);
      
      if (response.success) {
        setCommissions(response.commissions || []);
        setFilteredCommissions(response.commissions || []);
      }
    } catch (error) {
      console.error('Error fetching commissions:', error);
      alert('Failed to load commission reports');
    } finally {
      setLoading(false);
    }
  };

  // Use filtered commissions or all commissions
  const displayedCommissions = isFiltered ? filteredCommissions : commissions.slice(0, 5);
  const allDisplayedCommissions = isFiltered ? filteredCommissions : commissions;

  // Calculate summary based on actual API data
  const calculateSummary = (commissions) => {
    const totalCommissions = commissions.reduce((sum, comm) => sum + (comm.amount || 0), 0);
    
    const paidCommissions = commissions
      .filter(comm => comm.status === 'paid')
      .reduce((sum, comm) => sum + (comm.amount || 0), 0);

    const pendingCommissions = commissions
      .filter(comm => comm.status === 'pending')
      .reduce((sum, comm) => sum + (comm.amount || 0), 0);

    return {
      totalCommissions: `₹${totalCommissions.toLocaleString()}`,
      paidCommissions: `₹${paidCommissions.toLocaleString()}`,
      pendingCommissions: `₹${pendingCommissions.toLocaleString()}`,
      totalBookings: commissions.length
    };
  };

  const summary = calculateSummary(allDisplayedCommissions);

  const handleDateChange = (e) => {
    setDateRange({
      ...dateRange,
      [e.target.name]: e.target.value,
    });
  };

  const handleStatusFilterChange = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleFilter = (e) => {
    e.preventDefault();
    
    let filtered = [...commissions];

    // Apply date filter
    if (dateRange.startDate && dateRange.endDate) {
      filtered = filtered.filter(commission => {
        const commissionDate = new Date(commission.createdAt);
        const startDate = new Date(dateRange.startDate);
        const endDate = new Date(dateRange.endDate);
        
        return commissionDate >= startDate && commissionDate <= endDate;
      });
    }

    // Apply status filter
    if (statusFilter !== 'All') {
      filtered = filtered.filter(commission => commission.status === statusFilter.toLowerCase());
    }

    setFilteredCommissions(filtered);
    setIsFiltered(true);
  };

  const handleReset = () => {
    setDateRange({
      startDate: '',
      endDate: '',
    });
    setStatusFilter('All');
    setFilteredCommissions(commissions);
    setIsFiltered(false);
  };

  const handleExportCSV = () => {
    const commissionsToExport = isFiltered ? filteredCommissions : commissions;
    
    // Create CSV content
    const headers = ['Booking PNR', 'Customer Name', 'Journey Date', 'Route', 'Booking Amount', 'Commission Rate', 'Commission Amount', 'Status', 'Booking Date', 'Payment Date'];
    const csvContent = [
      headers.join(','),
      ...commissionsToExport.map(commission => [
        commission.booking?.pnr || 'N/A',
        `"${commission.booking?.seats?.[0]?.passenger?.fullName || 'N/A'}"`,
        commission.booking?.journeyDetails?.date ? new Date(commission.booking.journeyDetails.date).toLocaleDateString() : 'N/A',
        `"${commission.booking?.route?.routeName || 'N/A'}"`,
        `₹${commission.bookingAmount || 0}`,
        `${commission.commissionRate}%`,
        `₹${commission.amount || 0}`,
        commission.status,
        new Date(commission.createdAt).toLocaleDateString(),
        commission.paymentDate ? new Date(commission.paymentDate).toLocaleDateString() : 'N/A'
      ].join(','))
    ].join('\n');

    // Create and download CSV file
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', `commissions_report_${new Date().toISOString().split('T')[0]}.csv`);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleViewAll = () => {
    setShowAllCommissions(true);
  };

  const closeModal = () => {
    setShowAllCommissions(false);
  };

  const getStatusBadge = (status) => {
    const statusColors = {
      paid: '#48bb78',
      pending: '#ed8936'
    };
    
    return (
      <span 
        className={`status-badge status-${status}`}
        style={{ backgroundColor: statusColors[status] || '#718096' }}
      >
        {status?.charAt(0).toUpperCase() + status?.slice(1)}
      </span>
    );
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  if (loading) {
    return (
      <Layout>
        <div className="commissions-page">
          <div className="loading">Loading commission reports...</div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="commissions-page">
        <div className="page-header">
          <h1 className="page-title">Commission Reports</h1>
          <p className="page-subtitle">Track your commission earnings and performance</p>
        </div>

        {/* Summary Cards */}
        <div className="summary-cards">
          <div className="summary-card">
            <div className="summary-icon total">💰</div>
            <div className="summary-content">
              <h3>{summary.totalCommissions}</h3>
              <p>Total Commissions</p>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon paid">✅</div>
            <div className="summary-content">
              <h3>{summary.paidCommissions}</h3>
              <p>Paid Commissions</p>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon pending">⏳</div>
            <div className="summary-content">
              <h3>{summary.pendingCommissions}</h3>
              <p>Pending Commissions</p>
            </div>
          </div>
          <div className="summary-card">
            <div className="summary-icon bookings">📦</div>
            <div className="summary-content">
              <h3>{summary.totalBookings}</h3>
              <p>Total Bookings</p>
            </div>
          </div>
        </div>

        {/* Filters */}
        <div className="filters-section">
          <form onSubmit={handleFilter} className="filter-form">
            <div className="filter-group">
              <label htmlFor="startDate">From Date</label>
              <input
                type="date"
                id="startDate"
                name="startDate"
                value={dateRange.startDate}
                onChange={handleDateChange}
              />
            </div>
            <div className="filter-group">
              <label htmlFor="endDate">To Date</label>
              <input
                type="date"
                id="endDate"
                name="endDate"
                value={dateRange.endDate}
                onChange={handleDateChange}
              />
            </div>
            <div className="filter-group">
              <label htmlFor="statusFilter">Status</label>
              <select
                id="statusFilter"
                value={statusFilter}
                onChange={handleStatusFilterChange}
              >
                <option value="All">All Status</option>
                <option value="paid">Paid</option>
                <option value="pending">Pending</option>
              </select>
            </div>
            <button type="submit" className="filter-btn">
              Apply Filter
            </button>
            <button type="button" className="reset-btn" onClick={handleReset}>
              Reset
            </button>
          </form>
          {isFiltered && (
            <div className="filter-info">
              Showing {filteredCommissions.length} commissions 
              {dateRange.startDate && ` from ${dateRange.startDate} to ${dateRange.endDate}`}
              {statusFilter !== 'All' && ` with status: ${statusFilter}`}
            </div>
          )}
        </div>

        {/* Commissions Table */}
        <div className="commissions-table-container">
          <div className="table-header">
            <h3>Commission History</h3>
            <div className="table-actions">
              <button className="view-all-btn" onClick={handleViewAll}>
                View All
              </button>
              <button className="export-btn" onClick={handleExportCSV}>
                Export CSV
              </button>
            </div>
          </div>
          <div className="table-responsive">
            <table className="commissions-table">
              <thead>
                <tr>
                  <th>Booking PNR</th>
                  <th>Customer Details</th>
                  <th>Journey Details</th>
                  <th>Booking Amount</th>
                  <th>Commission Rate</th>
                  <th>Commission Amount</th>
                  <th>Booking Date</th>
                  <th>Status</th>
                  <th>Payment Date</th>
                </tr>
              </thead>
              <tbody>
                {displayedCommissions.map((commission) => (
                  <tr key={commission._id}>
                    <td className="booking-pnr">
                      {commission.booking?.pnr || 'N/A'}
                    </td>
                    <td className="customer-details">
                      <div className="customer-name">
                        {commission.booking?.seats?.[0]?.passenger?.fullName || 'N/A'}
                      </div>
                      <div className="customer-phone">
                        {commission.booking?.seats?.[0]?.passenger?.mobileNumber || 'N/A'}
                      </div>
                    </td>
                    <td className="journey-details">
                      <div className="route">
                        {commission.booking?.route?.routeName || 'N/A'}
                      </div>
                      <div className="journey-date">
                        {commission.booking?.journeyDetails?.date ? 
                          formatDate(commission.booking.journeyDetails.date) : 'N/A'
                        }
                      </div>
                      <div className="bus-type">
                        {commission.booking?.journeyDetails?.busType || 'N/A'}
                      </div>
                    </td>
                    <td className="booking-amount">
                      ₹{commission.bookingAmount?.toLocaleString() || 0}
                    </td>
                    <td className="commission-rate">
                      {commission.commissionRate}%
                    </td>
                    <td className="commission-amount">
                      <strong>₹{commission.amount?.toLocaleString() || 0}</strong>
                    </td>
                    <td className="booking-date">
                      {formatDate(commission.createdAt)}
                    </td>
                    <td>
                      {getStatusBadge(commission.status)}
                    </td>
                    <td className="payment-date">
                      {commission.paymentDate ? 
                        formatDate(commission.paymentDate) : 
                        <span className="not-applicable">N/A</span>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!isFiltered && commissions.length > 5 && (
              <div className="table-footer">
                <p>Showing 5 of {commissions.length} commissions</p>
              </div>
            )}
            {isFiltered && filteredCommissions.length === 0 && (
              <div className="table-footer">
                <p>No commissions found for the selected filters</p>
              </div>
            )}
            {commissions.length === 0 && (
              <div className="table-footer">
                <p>No commission records found</p>
              </div>
            )}
          </div>
        </div>

        {/* All Commissions Modal */}
        {showAllCommissions && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="modal-header">
                <h3>All Commissions ({allDisplayedCommissions.length})</h3>
                <button className="modal-close" onClick={closeModal}>×</button>
              </div>
              <div className="modal-body">
                <div className="commissions-table">
                  <table>
                    <thead>
                      <tr>
                        <th>Booking PNR</th>
                        <th>Customer</th>
                        <th>Journey Date</th>
                        <th>Route</th>
                        <th>Booking Amount</th>
                        <th>Commission Rate</th>
                        <th>Commission Amount</th>
                        <th>Status</th>
                        <th>Payment Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allDisplayedCommissions.map((commission) => (
                        <tr key={commission._id}>
                          <td className="booking-pnr">{commission.booking?.pnr || 'N/A'}</td>
                          <td className="customer">
                            {commission.booking?.seats?.[0]?.passenger?.fullName || 'N/A'}
                          </td>
                          <td className="journey-date">
                            {commission.booking?.journeyDetails?.date ? 
                              formatDate(commission.booking.journeyDetails.date) : 'N/A'
                            }
                          </td>
                          <td className="route">
                            {commission.booking?.route?.routeName || 'N/A'}
                          </td>
                          <td className="booking-amount">
                            ₹{commission.bookingAmount?.toLocaleString() || 0}
                          </td>
                          <td className="commission-rate">
                            {commission.commissionRate}%
                          </td>
                          <td className="commission-amount">
                            ₹{commission.amount?.toLocaleString() || 0}
                          </td>
                          <td>
                            {getStatusBadge(commission.status)}
                          </td>
                          <td className="payment-date">
                            {commission.paymentDate ? 
                              formatDate(commission.paymentDate) : 
                              <span className="not-applicable">N/A</span>
                            }
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-footer">
                <button className="export-btn" onClick={handleExportCSV}>
                  Export CSV
                </button>
                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default CommissionReport;